import React from 'react'

const ProcessManagementTips = () => {
    return (
        <div className="a-tabs-head-right channel-package-long-head-right">
            <div className="toolbar" style={{ lineHeight: '36px' }}>
                <div className="toolbar-left">
                    <div className="toolbar-left-inner">
                        <div className="tip-desc">
                            使用“本地上传渠道包”方式上传的渠道包，任务上传完成后将进入到校验处理流程中，上传过程中请不要刷新、关闭页面
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProcessManagementTips
